import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnDefinition, DynamicTableData, EditColumnOrderPayload } from '../../models/dynamic-table/dynamic-table-data.model';
import { APIResponse } from 'src/app/misc/saved-searches/components/predict-dialog/predict-interface';
import { IQuestionModel } from '../../components/chatbot-modal/model/chatbot.model';
import { WbEditAttachmentsPayload } from '../../models/dynamic-table/dynamic-table-document.model';
import { DownloadDocumentPayload } from '../../models/document-management/document-management.model';

@Injectable({
  providedIn: 'root'
})
export class DynamicTableService {
  private dynamicTableAPI: string;
  private configurationAPI: string;
  constructor(private http: HttpClient) {
    this.dynamicTableAPI = environment.dynamicTableAPI;
    this.configurationAPI = environment.configUrl;
  }

  uploadDynamicTable(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${this.dynamicTableAPI}DynamicTable`, formData, {})
  }

  // GET: Retrieve uploaded files 
  getDynamicTable(tableId: string, pageNumber: number, pageSize: number): Observable<any> {
    return this.http.get<DynamicTableData>(`${this.dynamicTableAPI}Workbook/${tableId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  // GET: Retrieve uploaded files 
  getGroupByDynamicTable(groupedObject:any): Observable<any> {
    return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Workbook/GroupedRecords`, groupedObject, {});
  }

  getFilteredDynamicTable(filteredObject:any): Observable<any> {
    return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Workbook/FilteredRecords`, filteredObject, {});
  }

  // GET: getDynamicTableColumn through str Id. 
  getDynamicTableColumn(workBookId:string): Observable<ColumnDefinition[]> {
    return this.http.get<ColumnDefinition[]>(`${this.dynamicTableAPI}Workbook/${workBookId}/Columns`);
  }

  // GET: getDynamicTableColumn through str Id
  getWorkbookColumnByIntID(workBookId:number): Observable<ColumnDefinition[]> {
  return this.http.get<ColumnDefinition[]>(`${this.dynamicTableAPI}Workbook/${workBookId}/ColumnsByIntId`);
}

  //Check column is associate with any widget
  checkWorkbookWidgetMapping(workBookId:string, columnId: string): Observable<any> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workbook/${workBookId}/Column/${columnId}/CheckWidgetMapping`);
  }

  // DELETE: Delete a file    
  deleteDynamicTable(fileId: string): Observable<any> {
    return this.http.delete(`${this.dynamicTableAPI}DynamicTable/${fileId}`);
  }

  //DeleteWorkspaceByID 
  deleteWorkbookByID(workbookId: string) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workbook/${workbookId}`);
  }

  getFormcontrolType(): Observable<any> {
    return this.http.get<any>(`${this.configurationAPI}Configuration/FormControls/?objectId=2`);
  }

  // PUT: Update an existing file 
  updateWorkbookName(workbookId: string, payload: any): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}`, payload);
  }

  //getWorkbookColumnDropdownValues.
  getWorkbookColumnDropdowns(columnId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Column/${columnId}/DropDownValues`);
  }

  getWorkbookColumnOptionValue(columnId: any, searchInput?: string): Observable<any[]> {
    let params = new HttpParams();
    
    if (searchInput) {
      params = params.set('searchInput', searchInput); // Append query parameter if searchInput exists
    }
  
    return this.http.get<any[]>(`${this.dynamicTableAPI}ColumnOptionValue/${columnId}`, { params });
  }
  

  createWorkbookColumn(newColumn:any): Observable<any> {
    return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Column`, newColumn, {});
  }

  // PUT: Update an existing file 

  updateWorkbookColumn(columnId: string, workbookColumn: any): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Column/${columnId}`, workbookColumn);
  }

  // PUT: updateWorkbookColumnFrozen

  updateWorkbookColumnFrozen(columnId: string, isFrozen: boolean): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Column/${columnId}/Freeze`, isFrozen);
  }

  updateWorkbookColumnOrder(editColumnOrderPayload: EditColumnOrderPayload): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Column/DisplayOrder`, editColumnOrderPayload);
  }
  

  //deleteWorkbookColumn 
  deleteWorkbookColumn(columnId: string) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Column/${columnId}`);
  }
  
  // addRowInWorkbook
  createWorkbookRow(workbookId: string,newRow:any): Observable<any> {
    return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Workbook/${workbookId}/Row`, newRow, {});
  }

  // PUT: updateWorkbookRow
  updateWorkbookRow(workbookId: string, modifiedRow:any): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/Row`, modifiedRow);
  }

  //getWorkbookRow
  getWorkbookRow(workbookId: string, rowNumber: number): Observable<any> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/Row/${rowNumber}`);
  } 

  //deleteWorkbookColumn 
  deleteWorkbookRow(workbookId: string, rowNumber: number) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/Row/${rowNumber}`);
  }

   //Get all dynamic forms throght a workbook ID.
   getDynamicFormsByWorkbookID(workbookId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/Forms`);
  }

  //Get all dynamic table Records throght a workbook ID.
  getDynamicTableWorkbookRecords(workbookId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/Records`);
  }

 // GET: Retrieve uploaded files 
 getWorkbookPredictionModel(workbookId: string, payload:any): Observable<any> {
  return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}/PredictionModel`, payload, {});
 }

 getWorkbookForecastModel(workbookId: string, payload:any): Observable<any> {
  return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}/ForecastPredictionModel`, payload, {});
 }

 PredictionModelMapping(workbookId: string) : Observable<APIResponse> {
  return this.http.get<APIResponse>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}/PredictionModelMapping`);
 }

 getPredictionModelInference(workbookId: string, payload:any): Observable<any> {
  return this.http.post<DynamicTableData>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}/PredictionModelInference`, payload, {});
 }

 getWorkbookAnalytics(workbookId: any) : Observable<any> {
  return this.http.get<any>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}`);
 }

 //chat
 initialize(workbookId: string): Observable<any> {
  return this.http.post<any>(`${this.dynamicTableAPI}Analytics/Workbook/${workbookId}/Initialize`, {});
 }

 getSampleQuestion(sessionId) : Observable<any> {
  return this.http.get<any>(`${this.dynamicTableAPI}Analytics/SampleQuestions/${sessionId}`);
 }

 askQuestions(questionData: IQuestionModel) {
    return this.http.post<any>(`${this.dynamicTableAPI}Analytics/ask`, questionData);
 }

 userInput(SaveUserInput) {
  return this.http.post<any>(`${this.dynamicTableAPI}Analytics/SaveUserInput`, SaveUserInput);
  }

//  Row level document related API 

   //Get all Document of a row through a workbook ID.
   getRowDocument(workbookId: string, rowNumber: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Document`);
  }
  // addRowInWorkbook
  createRowDocument(workbookId: string, rowNumber: number, data:any): Observable<any> {
    // console.log('dile data',data);
    const formData = new FormData();
    formData.append('formFile', data);
    // const headers = new HttpHeaders({
    //   'Content-Type': data.type // Use the file's MIME type
    // });
    return this.http.post<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Document`, formData, {});
  }

  // PUT: updateRowDocument
  updateRowDocument(workbookId: string, rowNumber: number, document:WbEditAttachmentsPayload): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Document`, document, {});
  }

  //deleteRowDocument 
  deleteRowDocument(workbookId: string, rowNumber: number, documentId: any) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Document/${documentId}`);
  }

  //download document
  downloadDocument(workbookId: string, rowNumber: number, documentId: number): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/Document/${documentId}/Download?isDefaultContentType=false`, {});
  }
  
  // updateWorkbookRowCommentStatus
  updateWorkbookRowCommentStatus(workbookId: string, isRead:boolean, rowNumber: number): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/${workbookId}/RowNumber/${rowNumber}/AddOrChangeAllCommentStatus`, isRead);
  }

  retainSavedFilterData(data: any): Observable<any> {
    return this.http.post(`${environment.dynamicTableAPI}Workbook/SavedFilter`, data);
  }

  getSavedFilterData(workbookId: string): Observable<any> {
    return this.http.get(`${environment.dynamicTableAPI}Workbook/${workbookId}/SavedFilter`);
  }
  getWorkbookColumnSetting(workbookId: any) : Observable<any> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workbook/${workbookId}/ColumnSetting`);
   }

  // addRowInWorkbook
  createWorkbookColumnSetting(column:any): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Workbook/ColumnSetting`, column, {});
  }

  // PUT: updateWorkbookRow
  updateWorkbookColumnSetting(updatedColumn: any): Observable<any> {
    return this.http.put(`${this.dynamicTableAPI}Workbook/ColumnSetting`, updatedColumn);
  }
  
  //Extenam form bulk upload
  bulkUploadDocumentForExternalFile(files: File[], OrganizationId:any, UserId:any, path: string, createUniqueName: boolean = true, overwrite: boolean = false): Observable<any> {
    const formData = new FormData();

    // Append files to FormData
    files.forEach(file => formData.append('Files', file));
    formData.append('OrganizationId', OrganizationId);
    formData.append('UserId', UserId);
    formData.append('Path', path);
    formData.append('CreateUniqueName', createUniqueName ? 'true' : 'false');
    formData.append('OverWrite', overwrite ? 'true' : 'false'); 
    return this.http.post(`${this.dynamicTableAPI}Document/BulkUpload`, formData, {})
  }

  downloadDocumentForExternalFile(downloadDocumentPayload: DownloadDocumentPayload): Observable<any> {
    return this.http.post(`${this.dynamicTableAPI}Document/Download`, downloadDocumentPayload, {})
  }

  deleteDocumentForExternalFile(id: number, organizationId: number, userId: number): Observable<any> {
    return this.http.delete(`${this.dynamicTableAPI}Document?Id=${id}&OrganizationId=${organizationId}&UserId=${userId}`);
  }
  
}
